export const callTypes = [
    {
        label: "Inbound",
        value: "inbound"
    },
    {
        label: "Outbound",
        value: "outbound"
    },
    {
        label: "Both",
        value: "both"
    }
];

export const sendEmail = [
    {
        label: "Lead Email",
        value: "lead_email"
    },
    {
        label: "Custom Email",
        value: "custom_email"
    },
];

export const sentTypes = [
    {
        label: "Custom phone number",
        value: "custom_ph_no"
    },
    {
        label: "Lead number",
        value: "contact_no"
    }
];